module.exports = require('./helpers/bundle-url').getBundleURL('bbWiP') + "logo.7718c6df.svg";